/** Grand totals display mode — Rows shows the Grand Total columns and Columns the Grand Total row. */
export enum PivotGrandTotalsEnum {
  Off = 'Off',
  On = 'On',
  Rows = 'Rows',
  Columns = 'Columns',
}
